import { render, staticRenderFns } from "./link-budget-requests-lightbox.vue?vue&type=template&id=fc37bd24"
import script from "./link-budget-requests-lightbox.vue?vue&type=script&lang=ts"
export * from "./link-budget-requests-lightbox.vue?vue&type=script&lang=ts"
import style0 from "./link-budget-requests-lightbox.vue?vue&type=style&index=0&id=fc37bd24&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc37bd24')) {
      api.createRecord('fc37bd24', component.options)
    } else {
      api.reload('fc37bd24', component.options)
    }
    module.hot.accept("./link-budget-requests-lightbox.vue?vue&type=template&id=fc37bd24", function () {
      api.rerender('fc37bd24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project-portfolio/project-portfolio-table/link-budget-requests-lightbox/link-budget-requests-lightbox.vue"
export default component.exports